import React, { createContext, useState, useContext, useEffect } from "react";

// Créez le contexte
const SelectedPointContext = createContext();

// Fournisseur de contexte
export const SelectedPointProvider = ({ children }) => {
  // Initialiser l'état avec la valeur dans localStorage (ou null si non défini)
  const [selectedPointId, setSelectedPointId] = useState(() => {
    const savedId = localStorage.getItem("selectedPointId");
    return savedId ? parseInt(savedId, 10) : null; // Convertir en entier ou retourner null
  });

  // Sauvegarder dans localStorage à chaque modification de l'ID
  useEffect(() => {
    if (selectedPointId) {
      localStorage.setItem("selectedPointId", selectedPointId);
    } else {
      localStorage.removeItem("selectedPointId");
    }
  }, [selectedPointId]);

  return (
    <SelectedPointContext.Provider value={{ selectedPointId, setSelectedPointId }}>
      {children}
    </SelectedPointContext.Provider>
  );
};

// Hook pour utiliser le contexte
export const useSelectedPoint = () => useContext(SelectedPointContext);
